import { useCallback, useEffect, useState } from "react";
import { api, extractList, getApiError } from "@/api/client";

export const useFeedData = (filters) => {
  const [state, setState] = useState({ items: [], count: 0, totalScanned: 0, loading: true, error: "" });
  const load = useCallback(async () => {
    setState((current) => ({ ...current, loading: true, error: "" }));
    try {
      const { data } = await api.get("/admin/feed", { params: {
        type: filters.type,
        creators_only: filters.creatorsOnly,
        verified_only: filters.verifiedOnly,
        country: filters.country || undefined,
        limit: filters.limit,
        skip: filters.skip,
        include_removed: filters.includeRemoved,
      } });
      setState({ items: extractList(data, ["items"]), count: Number(data?.count ?? 0), totalScanned: Number(data?.total_scanned ?? 0), loading: false, error: "" });
    } catch (error) { setState((current) => ({ ...current, loading: false, error: getApiError(error) })); }
  }, [filters]);
  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
};